// This file is part of re-motion
// Copyright (c) rubicon IT GmbH, www.rubicon.eu
// 
import { MessageServerContext } from "@lib/messaging/MessageServerContext";

/**
 * Defines an API for handling messages of a certain format (e.g. RPC).
 */
export interface IMessageFormatProvider
{
  handleMessage(context: MessageServerContext, message: object): void;
}